import React from 'react'
import { financial } from '../../core/controllers/Financial.js'
import moment from 'moment'

export default class RentProgressWidget extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            pendingIncome: null,
            lateTotal: null,
            receivedTotal: null,
        };

    }

    componentDidMount() {
        var self        = this
        const startDate = moment(moment().subtract(30, 'day').format("YYYY-MM-DD"));
        const endDate   = moment(moment().format("YYYY-MM-DD"));
        financial.getLateRent(startDate, endDate, function(lateResponse) {
            financial.getPendingRent(function(pendingResponse) {
                financial.getRentReceived(startDate, endDate, function(receivedResponse) {
                    self.setState({
                        pendingIncome: pendingResponse.data.income,
                        receivedTotal: receivedResponse.data.income,
                    });
                });
            });
        });
    }

    componentWillUpdate(nextProps, nextState) {
    }

    render(){
        var paidPercent = Math.ceil((this.state.receivedTotal / (this.state.receivedTotal + this.state.pendingIncome))*100);
        if (isNaN(paidPercent)) {
            paidPercent = "Rent Unavailable";
        } else {
            paidPercent = paidPercent.toString() + "% Collected";
        }
        var chartProgress = document.getElementById("rentChart");
        if (chartProgress) {
            var myChartCircle = new Chart(chartProgress, {
                type: 'doughnut',
                data: {
                    labels: ['Paid', 'Pending Income'],
                    datasets: [{
                        backgroundColor: ["#0078FF","#dce1e7"],
                        data: [this.state.receivedTotal, this.state.pendingIncome + this.state.lateTotal]
                    }],
                },
                plugins: [{
                    beforeDraw: function(chart) {
                        var width = chart.chart.width,
                            height = chart.chart.height,
                            ctx = chart.chart.ctx;

                        ctx.restore();
                        var fontSize = (height / 180).toFixed(2);
                        ctx.font = "bold " + fontSize + "em sans-serif";
                        ctx.fillStyle = "black";
                        ctx.textBaseline = "middle";

                        var text = paidPercent,
                            textX = Math.round((width - ctx.measureText(text).width) / 2),
                            textY = height / 2;

                        ctx.fillText(text, textX, textY);
                        ctx.save();
                    }
                }],
                options: {
                    legend: {
                        display: false
                    },
                    responsive: true,
                    maintainAspectRatio: true,
                    cutoutPercentage: 70,
                    tooltips: {
                        enabled: false
                    }
                }
            });
        }
        return (
            <div class="card">
                <div class="row">
                    <div class="header">
                        <h4 class="title">
                            Rent Collection
                        </h4>
                        <p class="category">Percentage of rent collected this month</p>
                    </div>
                        <canvas style={{ padding: '15px' }} id="rentChart" />
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// app/components/Widgets/RentProgressWidget.jsx